module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent-server-setup"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.set-parent-server')))]), _vm._v(" "), _c('data-form', {
    attrs: {
      "entity": _vm.server,
      "fields": _vm.fields,
      "cancel": false
    },
    on: {
      "submit": _vm.submit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77fff47c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/server/ParentServer.vue
// module id = 1170
// module chunks = 2